function maximumInvoicePayment({
  isCustomer,
  paymentSource,
  parentDueBalance,
  totalDueBalance,
  advanceAvailable,
}) {
  const invoiceDue = Math.max(0, Number(totalDueBalance || 0))
  if (!isCustomer) return invoiceDue

  const parentDue = Math.max(0, Number(parentDueBalance || 0))
  if (paymentSource === 'advance') {
    return Math.min(parentDue, Math.max(0, Number(advanceAvailable || 0)))
  }
  return parentDue
}

function isInvoicePaymentDisabled({
  total,
  totalDueBalance,
  paymentAmount,
  maximumPayment,
  paymentSource,
  advanceApplicationAmount,
  hasMerchant,
  hasCard,
}) {
  if (!(Number(total) > 0) || Number(total) > Number(totalDueBalance)) return true
  if (Number(paymentAmount || 0) > Number(maximumPayment)) return true
  if (paymentSource === 'advance') return !(Number(advanceApplicationAmount) > 0)
  if (paymentSource === 'online') return !hasMerchant || !hasCard
  return false
}

function isMultiInvoicePaymentDisabled({
  total,
  allocationCount,
  mode,
  hasMerchant,
  requiresCard,
  hasCard,
  advanceAvailable,
}) {
  if (!(Number(total) > 0) || !(Number(allocationCount) > 0)) return true
  if (mode === 'saved') return !hasMerchant || (requiresCard && !hasCard)
  if (mode === 'advance') return Number(total) > Number(advanceAvailable || 0)
  return false
}

function collectibleInvoiceDue({ isCustomer, totalDue, parentDue }) {
  const invoiceDue = Math.max(0, Number(totalDue || 0))
  if (!isCustomer) return invoiceDue
  const collectibleParentDue = parentDue === null || parentDue === undefined
    ? invoiceDue
    : Math.max(0, Number(parentDue || 0))
  return Math.min(invoiceDue, collectibleParentDue)
}

module.exports = { maximumInvoicePayment, isInvoicePaymentDisabled, isMultiInvoicePaymentDisabled, collectibleInvoiceDue }
